import React from 'react';
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
} from '@knockrentals/knock-shared-web';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles({
  aiNurtureListSkeleton: {
    background: '#FAFAFA',
    border: '1px solid transparent',
    borderRadius: '8px',
    marginBottom: '30px',
  },
});

const AiNurtureSkeleton = () => {
  const classes = useStyles();

  return (
    <List className={classes.aiNurtureListSkeleton}>
      <ListItem>
        <ListItemAvatar>
          <Skeleton
            aria-live="polite"
            height={32}
            role="status"
            variant="circle"
            width={32}
          />
        </ListItemAvatar>
        <ListItemText
          primary={
            <Skeleton
              aria-live="polite"
              height={12}
              role="status"
              variant="text"
              width={320}
            />
          }
          secondary={
            <Skeleton
              aria-live="polite"
              height={12}
              role="status"
              variant="text"
              width={320}
            />
          }
        />
        <ListItemSecondaryAction>
          <Skeleton
            aria-live="polite"
            height={32}
            role="status"
            variant="circle"
            width={32}
          />
        </ListItemSecondaryAction>
      </ListItem>
    </List>
  );
};

export default AiNurtureSkeleton;
